import React from "react";

const Summary = (props) => {
    
    return (
        <p>{props.summary}</p>
    )
}

export default Summary;